export const EditIcon = () => {
  return (
    <svg width="42" height="42" viewBox="0 0 42 42" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M0 12C0 5.37258 5.37258 0 12 0H30C36.6274 0 42 5.37258 42 12V30C42 36.6274 36.6274 42 30 42H12C5.37258 42 0 36.6274 0 30V12Z" fill="#3E3C37" />
      <path fillRule="evenodd" clipRule="evenodd" d="M26.7455 12.5556C26.3383 12.1484 25.6781 12.1484 25.271 12.5556C25.271 12.5556 14.9491 22.8774 14.5805 23.2461C14.2118 23.6147 12 30.2502 12 30.2502C12 30.2502 18.6355 28.0384 19.0041 27.6697C19.3728 27.3011 29.6946 16.9792 29.6946 16.9792C30.1018 16.5721 30.1018 15.9119 29.6946 15.5047L26.7455 12.5556Z" fill="white" />
    </svg>
  )
}
